import { useContext } from "react";

import AuthContext, { type AuthContextProps } from "./auth-context";

const useAuth = (): AuthContextProps => useContext(AuthContext);

export { useAuth };
